import { graphql } from "src/graphql/generated";

export const createCampaignInquiryMutation = graphql(/* GraphQL */ `
    mutation CreateCampaignInquiry($campaignInquiry: CreateCampaignInquiryInput!) {
        createCampaignInquiry(campaignInquiry: $campaignInquiry) {
            id
        }
    }
`);
